import { render, staticRenderFns } from "./TimeInterval.vue?vue&type=template&id=48d2cb10&scoped=true"
import script from "./TimeInterval.vue?vue&type=script&lang=js"
export * from "./TimeInterval.vue?vue&type=script&lang=js"
import style0 from "./TimeInterval.vue?vue&type=style&index=0&id=48d2cb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2cb10",
  null
  
)

export default component.exports